import type { ReactNode } from 'react';
import { FileText } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EntityListCompactItemProps {
  selected?: boolean;
  onClick?: () => void;
  content: ReactNode;
  actions?: ReactNode;
}

export function EntityListCompactItem({
  selected = false,
  onClick,
  content,
  actions,
}: EntityListCompactItemProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'group flex items-start gap-2 border-b px-3 py-2.5 transition-colors last:border-b-0',
        onClick && 'cursor-pointer',
        selected ? 'bg-accent' : onClick && 'hover:bg-muted/50',
      )}
    >
      <div className="min-w-0 flex-1">{content}</div>
      {actions}
    </div>
  );
}

interface EntityListCardItemProps {
  onClick: () => void;
  content: ReactNode;
  value?: ReactNode;
  actions?: ReactNode;
}

export function EntityListCardItem({ onClick, content, value, actions }: EntityListCardItemProps) {
  return (
    <div
      onClick={onClick}
      className="group mb-1.5 flex cursor-pointer items-center gap-3 rounded-lg border bg-card p-3 transition-shadow hover:shadow-sm"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-muted">
        <FileText size={16} className="text-muted-foreground" />
      </div>
      <div className="min-w-0 flex-1">{content}</div>
      {value ? <span className="shrink-0 text-sm font-semibold">{value}</span> : null}
      {actions}
    </div>
  );
}
